import icon1 from "../assets/User/default-icons/icon-1.png";
import icon2 from "../assets/User/default-icons/icon-2.png";
import icon3 from "../assets/User/default-icons/icon-3.png";
import icon4 from "../assets/User/default-icons/icon-4.png";
import icon5 from "../assets/User/default-icons/icon-5.png";
import bg1 from "../assets/HomePage/aboutus/bg-1.jpg";
import bg2 from "../assets/HomePage/aboutus/bg-2.jpg";
import bg3 from "../assets/HomePage/aboutus/bg-3.jpg";
import bg4 from "../assets/HomePage/aboutus/bg-4.jpg";
import bg5 from "../assets/HomePage/aboutus/bg-5.jpg";

export const membersData = [
  {
    id: 1,
    name: "Zi Lun Ma",
    Responsibility: "Full-stack Developer",
    imageUrl: bg1,
    avatarUrl: icon1,
  },
  {
    id: 2,
    name: "SiCong Fu",
    Responsibility: "Full-stack Developer",
    imageUrl: bg2,
    avatarUrl: icon2,
  },
  {
    id: 3,
    name: "Jinchao Yuan",
    Responsibility: "Backend Developer",
    imageUrl: bg3,
    avatarUrl: icon3,
  },
  {
    id: 4,
    name: "Silin Li",
    Responsibility: "Frontend and UI/UX designer",
    imageUrl: bg4,
    avatarUrl: icon4,
  },
  {
    id: 5,
    name: "Tao Xu",
    Responsibility: "Frontend Developer and AI model",
    imageUrl: bg5,
    avatarUrl: icon5,
  },
];